export const DATE_DISPLAY_FORMAT = 'ddd, D MMM';
